<template>
  <section class="w-screen h-screen absolute flex justify-center items-center z-50">
    <div id="modal modal-unit" class="modal absolute block bg-white dark:bg-dark-800 w-5/6 sm:w-9/12 md:w-5/12 max-w-lg shadow-md rounded-lg dark:shadow-dark-600" :class="{
      'animate__animated animate__zoomIn': showModal,
      'animate__animated animate__zoomOut': !showModal,
    }">
      <div id="modal-header" class="w-full bg-color-1 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">{{ isEdit ? 'Edit Unit' : 'Tambah Unit' }}</h5>
      </div>
      <div id="modal-body" class="p-5 space-y-4 max-h-[calc(100dvh-220px)] overflow-y-auto">
        <InputTextCustom v-model="unitName" id="unit-name" label="Nama Satuan Unit"
          placeholder="Masukkan nama satuan unit" :valid="validation.name.valid"
          :error-message="validation.name.message" />
      </div>
      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600" @click="closeModal" />
          <SubmitButton id="submit" button_name="Submit" button_class="mx-1 bg-color-1 hover:bg-color-2 text-color-4"
            @click="submitUnit" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import InputTextCustom from '../form/InputTextCustom.vue';
import SubmitButton from '../form/SubmitButton.vue';
import { mapActions } from 'vuex';

export default {
  name: "ModalUnit",
  props: {
    unit: {
      type: Object,
      default: null,
    }
  },
  components: {
    SubmitButton, InputTextCustom
  },
  data() {
    return {
      showModal: true,
      unitCode: this.unit ? this.unit.code : '',
      unitName: this.unit ? this.unit.name : '',
      isEdit: !!this.unit,
      validation: {
        name: {
          valid: true,
          message: ''
        },
      },
      field: ['name'],
    }
  },
  watch: {
    unit(newVal) {
      if (newVal) {
        this.unitCode = newVal.code;
        this.unitName = newVal.name;
        this.isEdit = true;
      } else {
        this.unitCode = '';
        this.unitName = '';
        this.isEdit = false;
      }
    }
  },
  methods: {
    ...mapActions('units', ['createUnit', 'updateUnit']),
    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200);
    },
    submitUnit() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan satuan unit?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postUnit();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan satuan unit', life: 3000 });
        }
      });
    },
    async postUnit() {
      try {
        const unitData = {
          name: this.unitName
        };

        if (this.isEdit && this.unit) {
          unitData.id = this.unit.id;
          await this.updateUnit(unitData);
        }
        else {
          await this.createUnit(unitData);
        }

        this.closeModal();
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Satuan unit berhasil disimpan', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save unit:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    }
  }
}
</script>